module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAASCAYAAACNdSR1AAAAt0lEQVQ4T+2SMQrCQBREZ7Zwk047r+B1tBAUtNDaTg9hpbZiYyFY6HW8gl2skr9FdiSCEAJiLfi7PzwYGB4ltUII6xjjhGQHjZOUOeeO3vsVzWwjqQvg1gRrf4/kvYIzkjPv/fUTHELol2V5YFEUcs4NvsExxssfruaspvvpNQCcv4kEYPgSSVK7JtEpSZKZmR0AjN55pSrzPN+SXDTguZntAYzfOakda/JPSdYbXpykB4BjmqbLJ2O21Vnnab0BAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon.png
// module id = k3R8
// module chunks = 15